import React from 'react';
import { Grid } from '@material-ui/core';
import style from './style.module.css';

// eslint-disable-next-line no-shadow
const Item = ({ item, site }) => {
  let sourceUrl = null;
  if (item._embedded['wp:featuredmedia'] == null || item._embedded['wp:featuredmedia'] === "" || typeof item._embedded['wp:featuredmedia'] === "undefined") {
    // console.log("No!");
  } else {
    // console.log("Okay");
    sourceUrl = item._embedded['wp:featuredmedia'][0].source_url;
  }
  return (
    <Grid item md={2} xs={12} className={style.itemWrapper}>
      <a className={style.itemInner} href={`${site}?p=${item.id}`}>
        <div className={style.mediaWrapper}>
          <div className={style.backgroundWrapper} style={{ backgroundImage: `url(${sourceUrl})` }}></div>
        </div>
        <div className={style.textWrapper}>
          { item.title.rendered }
          {/* eslint-disable-next-line max-len */}
          <div className={style.excerpt} dangerouslySetInnerHTML={{ __html: item.excerpt.rendered }}>
          </div>
        </div>
      </a>
    </Grid>
  );
};

class Contents extends React.Component {
  render() {
    const items = this.props.items;
    if (items != null && items.length > 0) {
      const listItems = items.map((itemData, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Item item={(itemData)} key={(index)} site={this.props.site} />
      ));
      return (
        <>
          <Grid className={style.itemRow} container direction="row" justify="flex-start" alignItems="flex-start" spacing={3}>
            { listItems }
          </Grid>
        </>
      );
    // eslint-disable-next-line no-else-return
    } else {
      return (
        <h1>No Data</h1>
      );
    }
  }
}

export default Contents;
